import axios from "axios";
import {api} from "@/api";
import Const from "../helpers/Const";

export const DataMixin = {
  data() {
    return {
      onload: false,
      Const,
    }
  },

  methods: {
    // 날짜 포멧 변환 (YYYY년 MM월 DD일)
    getDateFormat(date, format = "YYYY년MM월DD일") {
      return this.$moment(date).format(format);
    },

    // pkg 데이터 최초 get 후 사용성에 따라 가공하기
    getPkgs(vtg_id = false) {
      axios.get(api.pkgs , { params: {
        filters:{
          dates: {
            title: '기간 검색',
            key: 'dates',
            val: 'dates',
            start_date: this.$moment().format('YYYY-MM-DD'),
            stop_date: this.$moment().format('YYYY-MM-DD'),
          },
        }
      }})
        .then(({data}) => {
          this.setItems(data.data.reverse());
          this.setUser(vtg_id);
        })
        .catch(error => {
          throw error;
        });
    },

    // 구독만료일까지 남은 날짜 계산
    getSubscDateStopRemain(date) {
      const today = this.$moment().startOf('days');
      const stopDate = this.$moment(date).startOf('days');
      const remainDate = stopDate.diff(today, 'days');
      return remainDate;
    },

    // 구독기간 (연단위) 텍스트 계산 및 출력용
    getSubscPeriod() {
      return "가입승인 후\n익일 00시부터 12개월";
      // let startDate = this.$moment().format('YYYY-MM-DD');
      // if (start_date)
      //   startDate = this.$moment(start_date).format('YYYY-MM-DD');
      // const start = this.getDateFormat(startDate);
      // const nextYear = this.$moment(startDate).add('days', 364).format('YYYY년MM월DD일');
      // return start + ' ~ ' + nextYear;
    },

    getVehicleNumRegDiff(car_reg_date) {
      if(car_reg_date === null || car_reg_date === undefined || car_reg_date === '') return 0;

      const today = this.$moment();
      const carRegDate = this.$moment(car_reg_date);
      // ex) 20년 1월 15일 ~ 20년 2월 14일까지 1개월, 20년1월15일~20년2월15일 부터는 2개월
      const diffMonth = today.diff(carRegDate, 'months') + 1;
      return diffMonth;
    },

    // 차량 등록일로부터 연식(개월수) 계산 & 가격단위 index 로 계산
    getVehicleNumRegMonthDiff(car_reg_date) {

      if( car_reg_date == null ) return 'reg_date_null'

      const diffMonth = this.getVehicleNumRegDiff(car_reg_date);
      // alert('month : '+diffMonth);
      if (diffMonth <= 48) return 0;      // 48개월 이하
      else if (49 <= diffMonth && diffMonth <= 60) return 1;    // 49~60 개월
      else if (61 <= diffMonth && diffMonth <= 72) return 2;    // 61~72 개월
      else if (73 <= diffMonth && diffMonth <= 84) return 3;    // 73~84 개월
      else if (85 <= diffMonth && diffMonth <= 96) return 4;    // 85~96 개월
      else if (97 <= diffMonth && diffMonth <= 108) return 5;   // 97~108 개월
      else if (109 <= diffMonth && diffMonth <= 120) return 6;  // 109~120 개월
      else if (121 <= diffMonth) return 7;                      // 121 개월 이상
    },

    setItems(items) {
      const pkgs = {};
      const prods = {};
      const vehicleCats = {};
      items.forEach(item => {
        // pkg setting
        pkgs[item.id] = {
          id: item.id,
          is_assurance: false, // prods 에서 검사해서 값 변경
          pkg: item.title,
          pkg_title: item.title,
          group: item.group,
          title: item.title,
          // title: item.title + " 패키지",
          atts:item.atts,     // front img
        };
        if (item.promos) {
          item.promos.forEach(promo => {
            const promoItem = {
              id: promo.id,
              type: promo.type,
              title: promo.title,
              rate: promo.rate,
              type_rate: promo.type_rate,
              cut_standard: promo.cut_standard,
              cut_unit: promo.cut_unit,
            }

            if(promo.state == Const.PROMO.STATE.ENABLE){
              // promo는 type 따라서
              switch (promo.type) {
                case Const.PROMO_TYPE_SUBSC_NEW: // 신규구독 : pkg->promo
                  pkgs[item.id].promo = promoItem;
                  break;
                case Const.PROMO_TYPE_SUBSC_EXT: // 연장구독 : pkg->promo_extend
                  pkgs[item.id].promo_extend = promoItem;
                  break;
              }
            }
            
          });
        }

        // prod setting
        const itemProds = [];
        item.prods.forEach(prod => {
          itemProds.push({
            seq: (prod.options.seq) ? Number(prod.options.seq) : 99,
            content: prod.content,    // 상세설명
            icon: Const.PROD.ICON[prod.options.icon],  // icon key: Const와 동기화
            id: prod.id,
            on: false,
            title: prod.title,
            type: prod.type,
            unit: prod.pivot.unit,
            unit_type: prod.pivot.unit_type,
          });
          // 보험적용 여부
          if (prod.type == Const.PROD.TYPE.ASSURANCE) {
            pkgs[item.id].is_assurance = true;
          }
        });
        prods[item.id] = itemProds;

        // vehicle category setting
        const itemVehicleCats = {};
        item.vehicle_cats.forEach(category => {
          itemVehicleCats[category.id] = {
            costs: category.pivot.costs,
            id: category.id,
            seq: category.seq,
            title: category.title,
            group: category.group,
            default: (category.options && category.options.default) ? category.options.default : -1
          };
        });

        vehicleCats[item.id] = itemVehicleCats;
      });
      this.$store.commit('setItems', {pkgs: pkgs, prods: prods, vehicle_cats: vehicleCats});
    },

    // user data server에서 조회 후 vuex저장 후 여기에서 onload 처리 20.04.08  sang
    // paramater로 받은 plus_id값 활용, plus user data local(vuex)에 저장
    setUser(vtg_id) {
      // 현재 URL의 파라미터 가져오기
      //const urlParams = new URLSearchParams(window.location.search);

      // 'id' 파라미터의 값을 가져오기
      //const user_ci = urlParams.get('ci');
      // let user_vtgID = this.$cookies.get('user_vtgID');

      // const plus_id = this.$route.query.plus_id;
      axios.get(`${api.vtg.users}/showVtgUser`, { params:{ type:'userEmail', vtg:vtg_id } })
        .then(({data}) => {
          const userData = data.data;
          if (userData) {
            // user 계정으로 plus에 등록된 차량 저장(구독 시 사용)
            const userVehicles = [];
            userData.vehicleList.forEach((item) => {
              // 모델이 BMW 인 차량만 구독신청 가능

              if (item.solMakeName && item.solMakeName.indexOf('BMW') != -1 ) {
                userVehicles.push({
                  num_id: item.solChassisNo,
                  num_reg: item.solRegistrationNumber,
                  model: item.solViewVehicleName,
                })
              }
            })

            var user = (this.$cookies.isKey("app_token")) ? this.$cookies.get("app_token").user : false;

            if (user) {
              this.$store.commit("setUser", {
                id: user.id,
                email: user.email,
                name: user.name,
                vtg_id: user.vtg_id,
                vtg_no: user.vtg_no,
                mobile: user.mobile,
                vehicles: userVehicles,
                connInfo: user.ci,
              });
            } else {
              this.$store.commit("setUser", {
                email: userData.usrEmail,
                name: userData.usrAuthName,
                vtg_id: userData.usrEmail,
                vtg_no: userData.usrNo,
                mobile: userData.usrMobileNo,
                vehicles: userVehicles,
                connInfo: userData.connInfo,
              });
            }
            
          }
          this.onload = true;
        })
        .catch(() => {
          this.onload = true;
        })
    },

    checkMobile(){
      var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
  
      if ( varUA.indexOf('android') > -1) { 
        return "android";
      } else if ( varUA.indexOf("iphone") > -1||varUA.indexOf("ipad") > -1||varUA.indexOf("ipod") > -1 ) {
        return "ios";
      } else {
         //아이폰, 안드로이드 외
         return "other";
      } 
    }
  },

}
